/**
 * 首页数据
 */
import { createStore } from '@souche-f2e/muji';
import { getState } from '@@/store';
import Api from '@/services';
export default createStore({
    state: {
        updateTime: '',
        applyCarCount: '',
        auctionCount: '',
        dealedOrderMoney: '',
        dealedRate: '',
        yesApplyCarCount: '',
        yesAuctionCount: '',
        yesDealedCarCount: '',
        yesDealedRate: '',
        carList: [],
        moneyList: [],
        carNum: 0,
        moneyNum: 0,
        // 权限
        P_data: 'psgjb-home-data',
        P_finance: 'psgjb-home-finance',
        P_auction: 'psgjb-home-auction',
        // 是否展示暂无权限图
        isShowNo: false,
        hasALlAuth: false,
        hasMyAuth: false,
    },
    effects: {
        /**
        * 首页数据概览
        */
        getHomeDataPreview(params) {
            Api.report.homeDataPreview({ tenantCode: getState().userInfo.user.tenantCode || '' }).then((data) => {
                if (data) {
                    this.SET_STATE({
                        updateTime: data.updateDate,
                        applyCarCount: data.aucCnt,
                        auctionCount: data.dealCarCnt,
                        dealedOrderMoney: data.dealOrderAmtW,
                        dealedRate: data.dealRate && (data.dealRate * 100).toFixed(2),
                        yesApplyCarCount: data.aucCntByYesterDay,
                        yesAuctionCount: data.dealCarCntByYesterDay,
                        yesDealedCarCount: data.dealOrderAmtByYesterDayW,
                        yesDealedRate: data.dealRateByYesterDay && (data.dealRateByYesterDay * 100).toFixed(2),
                    });
                }
            })
                .catch((err) => {
                console.log(err);
            });
        },
        /**
         * 交易中心 获取当月累计申请车辆
         */
        getApplyCarCount() {
            Api.goods.getApplyCarCount().then((data) => {
                if (typeof data === 'number') {
                    this.SET_STATE({ applyCarCount: data });
                }
            })
                .catch((err) => {
                console.log(err);
            });
        },
        /**
         * 竞价中心 获取当月累计发拍车辆
         */
        getAuctionCount() {
            Api.auction.getAuctionCount().then((data) => {
                if (typeof data === 'number') {
                    this.SET_STATE({ auctionCount: data });
                }
            })
                .catch((err) => {
                console.log(err);
            });
        },
        /**
         * 交易中心 当月累计成交车辆
         */
        getDealedCarCount() {
            Api.goods.getDealedCarCount().then((data) => {
                if (typeof data === 'number') {
                    this.SET_STATE({ dealedCarCount: data });
                }
            })
                .catch((err) => {
                console.log(err);
            });
        },
        /**
         * 交易中心 首页车辆发拍待审批的列表
         */
        getIndexList() {
            const req = {
                pageSize: 5,
                pageNum: 1,
                status: 10,
            };
            Api.goods.getIndexList(req).then((data) => {
                if (data && data.carInfoList) {
                    const carList = data.carInfoList;
                    carList.forEach((item) => {
                        if (item && item.createTime) {
                            item.web_timestamp = new Date(item.createTime).getTime();
                        }
                        if (item && item.registerDate) {
                            const time = new Date(item.registerDate);
                            const year = time.getFullYear();
                            let month = '';
                            if (time.getMonth() + 1 < 10) {
                                month = `0${time.getMonth() + 1}`;
                            }
                            else {
                                month = `${time.getMonth() + 1}`;
                            }
                            let day = '';
                            if (time.getDate() < 10) {
                                day = `0${time.getDate()}`;
                            }
                            else {
                                day = `${time.getDate()}`;
                            }
                            item.RegisterDate = `${year}-${month}-${day}`;
                        }
                    });
                    carList.sort((a, b) => {
                        if (a.web_timestamp > b.web_timestamp) {
                            return -1;
                        }
                        if (a.web_timestamp < b.web_timestamp) {
                            return 1;
                        }
                    });
                    this.SET_STATE({ carList });
                }
                if (data && data.count) {
                    const carNum = data.count;
                    this.SET_STATE({ carNum });
                }
                if (data && (data.hasALlAuth || data.hasMyAuth)) {
                    if (data.hasALlAuth) {
                        const hasALlAuth = data.hasALlAuth;
                        this.SET_STATE({ hasALlAuth });
                    }
                    if (data.hasMyAuth) {
                        const hasMyAuth = data.hasMyAuth;
                        this.SET_STATE({ hasMyAuth });
                    }
                }
            })
                .catch((err) => {
                console.log(err);
            });
        },
        /**
         * 订单中心 订单财务首页页面数据视图调用接口
         */
        getOrderPendingViewList() {
            const data = {
                pageSize: 5,
                pageCurrent: 1,
                pageStart: 0,
                tenantCode: 0,
                statusCode: 65,
            };
            Api.order.getOrderPendingViewList(data).then((data) => {
                if (data && data.items) {
                    const moneyList = data.items;
                    moneyList.forEach((item) => {
                        if (item && item.orderPayCreateTime) {
                            item.web_timestamp = new Date(item.orderPayCreateTime).getTime();
                        }
                    });
                    moneyList.sort((a, b) => {
                        if (a.web_timestamp > b.web_timestamp) {
                            return -1;
                        }
                        if (a.web_timestamp < b.web_timestamp) {
                            return 1;
                        }
                    });
                    this.SET_STATE({ moneyList });
                }
                if (data && data.totalNumber) {
                    const moneyNum = data.totalNumber;
                    this.SET_STATE({ moneyNum });
                }
            })
                .catch((err) => {
                console.log(err);
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        SET_auctionCount(state, payload) {
            state.auctionCount = payload;
        },
    },
});
